// currencies.js - Constants for currency options.
// Updated: Made 'value' unique to avoid duplicate keys in React lists (e.g., distinct symbols for CAD, AUD, SGD, CNY).
export const CURRENCY_OPTIONS = [
  { value: '$', label: 'USD (United States Dollar)' },
  { value: '£', label: 'GBP (British Pound Sterling)' },
  { value: '¥', label: 'JPY (Japanese Yen)' },
  { value: 'C$', label: 'CAD (Canadian Dollar)' },  // Updated: Unique symbol to avoid duplicate '$'
  { value: 'A$', label: 'AUD (Australian Dollar)' }, // Updated: Unique symbol to avoid duplicate '$'
  { value: 'S$', label: 'SGD (Singapore Dollar)' },  // Updated: Unique symbol to avoid duplicate '$'
  { value: '元', label: 'CNY (Chinese Renminbi)' },   // Updated: Unique symbol to avoid duplicate '¥'
  { value: '₿', label: 'BTC (Bitcoin)' },
  { value: '€', label: 'EUR (Euro)' },
];